import { useEffect, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import AnimatedMainContainer from "../../components/AnimatedMainContainer";
import {
  Container,
  NewFlowButton,
  Title,
  HeaderContainer,
  FlowsGrid,
  FilterContainer,
  LeftHeaderContent,
  ShowMoreButton,
  FilterSelect,
} from "./styles";
import { HiPlus } from "react-icons/hi";
import FlowCard from "./components/FlowCard";
import { Empty, Select } from "antd";
import api from "../../service";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import { useToast } from "../../hooks/toast";

const AdminUploadDocuments = () => {
  const { Option } = Select;
  const intl = useIntl();
  const { token } = useSelector((state) => state.auth);
  const [showAll, setShowAll] = useState(false);
  const [flows, setFlows] = useState([]);
  const history = useHistory();
  const { addToast } = useToast();

  const [dateFiltered, setDateFiltered] = useState(
    `${intl.formatMessage({ id: "MONTH/YEAR" })} ${String(
      new Date().getMonth() + 1
    ).padStart(2, "0")}/${new Date().getFullYear()}`
  );

  useEffect(() => {
    fetchUploadFlow();
  }, []);

  const fetchUploadFlow = async () => {
    setFlows([]);
    try {
      const response = await api.get("/upload-flow", {
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
          Authorization: `Bearer ${token}`,
        },
      });

      const sortedFlows = response.data.flows.sort(
        (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
      );

      setFlows(sortedFlows);

      if (sortedFlows.length > 0) {
        const latestDate = new Date(sortedFlows[0].createdAt);
        const latestMonthYear = `${String(latestDate.getMonth() + 1).padStart(
          2,
          "0"
        )}/${latestDate.getFullYear()}`;
        setDateFiltered(latestMonthYear);
      }
    } catch (err) {
      addToast({
        type: "error",
        title: intl.formatMessage({ id: "error" }),
        description: intl.formatMessage({
          id: "api.error." + err.response?.data?.description,
        }),
      });
    }
  };

  const filteredFlows = flows.filter((flow) => {
    const flowMonthYear = new Date(flow.createdAt).toLocaleDateString("pt-BR", {
      month: "2-digit",
      year: "numeric",
    });
    return flowMonthYear === dateFiltered;
  });

  const monthsOptions = Array.from(
    new Set(
      flows.map((flow) =>
        new Date(flow.createdAt).toLocaleDateString("pt-BR", {
          month: "2-digit",
          year: "numeric",
        })
      )
    )
  );

  const visibleFlows = showAll ? filteredFlows : filteredFlows.slice(0, 12);

  return (
    <AnimatedMainContainer
      breadcrumb={`
        ${intl.formatMessage({ id: "sidebar.upload_documents" })} |
        ${intl.formatMessage({ id: "sidebar.document_upload_flow" })}
      `}
    >
      <Container>
        <HeaderContainer>
          <LeftHeaderContent>
            <Title>
              <FormattedMessage id="FLOWS" />
            </Title>
            <FilterContainer>
              <FilterSelect
                placeholder={`${intl.formatMessage({
                  id: "MONTH/YEAR",
                })}: ${dateFiltered}`}
                style={{ width: 167 }}
                value={dateFiltered}
                onChange={(value) => setDateFiltered(value)}
              >
                {monthsOptions.map((month) => (
                  <Option key={month} value={month}>
                    {`${intl.formatMessage({ id: "MONTH/YEAR" })}: ${month}`}
                  </Option>
                ))}
              </FilterSelect>
            </FilterContainer>
          </LeftHeaderContent>

          <NewFlowButton
            data-test="new-upload-flow"
            onClick={() => history.push("/admin/upload-documents/flow/new")}
          >
            <HiPlus size={22} />
            {intl.formatMessage({ id: "NEW_FLOW" })}
          </NewFlowButton>
        </HeaderContainer>
        <FlowsGrid>
          {visibleFlows.map((flow) => (
            <FlowCard
              data-test="upload-flow-card"
              key={flow.id}
              fetchFlows={fetchUploadFlow}
              id={flow.id}
              name={flow.name}
              date={new Date(flow.createdAt).toLocaleDateString("pt-BR", {
                month: "2-digit",
                year: "numeric",
              })}
              availableForInactivation={flow.hasExecutions}
              active={flow.active}
              documentPackage={flow.documentPackage}
            />
          ))}
        </FlowsGrid>

        {!showAll && filteredFlows.length > 12 && (
          <ShowMoreButton onClick={() => setShowAll(true)}>
            {intl.formatMessage({ id: "SHOW_MORE" })}
          </ShowMoreButton>
        )}
        {flows.length === 0 && <Empty />}
      </Container>
    </AnimatedMainContainer>
  );
};

export default AdminUploadDocuments;
